// extracted by mini-css-extract-plugin
module.exports = {"background":"bc_d6","values":"bc_d7"};